import {useState, useCallback} from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import Map from './Map';
import Panel from './Panel'
import './App.css';

function App() {
  const [sideLength, setSideLength] = useState(50);
  const [cityName, setCityName] = useState('');

  const onSideLengthChange = useCallback((length) => setSideLength(length), []);
  const onCityNameChange = useCallback((name) => setCityName(name), []);

  return (
    <div className="App">
      <Map {...{sideLength, cityName}}/>
      <Panel {...{sideLength, onSideLengthChange, cityName, onCityNameChange}} />
    </div>
  );
}

export default App;
